import apiCall from 'apps/investcore/apiCalls/fund-distributors';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';

export const InvestmentFundDistributorsListPage = () => (
  <ListPage
    title="All Fund Distributors"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
  />
);

export const InvestmentFundDistributorsDetailPage = () => (
  <DetailPage
    title="Fund Distributor"
    apiCall={apiCall}
    listUrl={`/admin/fund-distributors`}
    ItemDetail={ItemDetail}
    options={{ editEnabled: false }}
  />
);
